import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ShiftPatternEntity } from 'src/entities/ShiftPattern.entity';

export const SHIFT_PATTERNS_PATH = '/api/v5/shift_patterns';

export const shiftPatternsQueryKey = (selectedCompanyId: number) =>
  ['useQueryShiftPatterns', selectedCompanyId] as const;

const getAll = () => async (): Promise<ShiftPatternEntity[]> => {
  const response = await axios.get<ShiftPatternEntity[]>(SHIFT_PATTERNS_PATH);
  return response.data;
};

export const useQueryShiftPatterns = (selectedCompanyId: number, enabled: boolean) => useQuery({
  queryKey: shiftPatternsQueryKey(selectedCompanyId),
  queryFn: getAll(),
  enabled,
  staleTime: Infinity,
});
